import React from 'react';

interface BlockIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const BlockIcon: React.FC<BlockIconProps> = ({ className = '', color = '#2C6CFF', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M20.603 6.0957C22.0118 7.85136 22.8569 10.078 22.8569 12.5C22.8569 18.1539 18.2608 22.75 12.6069 22.75C10.1974 22.75 7.98142 21.9133 6.22998 20.5176C6.28555 20.4779 6.33974 20.4342 6.39014 20.3838L6.60107 20.1719C8.2579 21.4718 10.3426 22.25 12.6069 22.25C17.9831 22.25 22.3569 17.8761 22.3569 12.5C22.3569 10.2357 21.5787 8.15097 20.2788 6.49414L20.3901 6.38379C20.477 6.29689 20.5473 6.19899 20.603 6.0957ZM5.49463 19.1582C5.60846 19.2797 5.72537 19.3981 5.84521 19.5137L5.68311 19.6768C5.63198 19.7277 5.5716 19.7499 5.50732 19.75C5.44286 19.75 5.38182 19.7279 5.33057 19.6768C5.23583 19.582 5.23583 19.418 5.33057 19.3232L5.49463 19.1582ZM18.5581 6.09473C18.68 6.20811 18.7982 6.32523 18.9136 6.44531L6.55225 18.8066C6.43217 18.6913 6.31504 18.5731 6.20166 18.4512L18.5581 6.09473ZM12.6069 2.25C14.9756 2.25 17.1569 3.05891 18.894 4.41211C18.7971 4.46642 18.7057 4.53409 18.6235 4.61621L18.4995 4.73926C16.8614 3.49247 14.8197 2.75 12.6069 2.75C7.23079 2.75 2.85693 7.12386 2.85693 12.5C2.85693 14.7127 3.5994 16.7545 4.84619 18.3926L4.62354 18.6162C4.57761 18.6621 4.53674 18.7117 4.49951 18.7627C3.15788 17.0295 2.35693 14.8574 2.35693 12.5C2.35693 6.84614 6.95308 2.25 12.6069 2.25ZM19.3306 5.32324C19.4252 5.2288 19.5884 5.22886 19.6831 5.32324C19.7778 5.41798 19.7778 5.58202 19.6831 5.67676L19.6206 5.73828C19.505 5.61844 19.3867 5.50152 19.2651 5.3877L19.3306 5.32324Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default BlockIcon;
